import React from 'react';
import { CheckboxFilterGroupProps } from './types';

const CheckboxFilterGroup: React.FC<CheckboxFilterGroupProps> = ({ options, selectedValues, onChange }) => {
  const handleToggle = (value: string) => {
    onChange(selectedValues.includes(value) ? selectedValues.filter((v) => v !== value) : [...selectedValues, value]);
  };

  return (
    <div className="fs-checks">
      {options.map((option) => {
        const isSelected = selectedValues.includes(option.value);
        const isDisabled = option.count === 0 && !isSelected;
        return (
          <label key={option.value} className={`fs-check ${isSelected ? 'is-on' : ''} ${isDisabled ? 'is-disabled' : ''}`}>
            <input
              type="checkbox"
              checked={isSelected}
              onChange={() => !isDisabled && handleToggle(option.value)}
              disabled={isDisabled}
            />
            <span className="fs-check-label">{option.label}</span>
            {option.count !== undefined && <span className="fs-check-count">{option.count}</span>}
          </label>
        );
      })}
    </div>
  );
};

export default CheckboxFilterGroup;
